import { Box, Button, Grid } from '@material-ui/core';
import Highcharts from 'highcharts';
import React from 'react';
import moment from 'moment';
import NoDataToDisplay from 'highcharts/modules/no-data-to-display';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { CustomDateFnsUtils } from '@jda/lui-common-component-library';

const DateComp = (props: any) => {
  NoDataToDisplay(Highcharts);

  const today = new Date();
  const date1 = moment(new Date(today.getFullYear(), today.getMonth(), 1)).format('YYYY-MM-DD');
  const date2 = moment(new Date(today.getFullYear(), today.getMonth() + 1, 0)).format('YYYY-MM-DD');

  const [startDate, setStartDate] = React.useState<any>(date1);
  const [endDate, setEndDate] = React.useState<any>(date2);

  const handleStartDate = (date: any) => {
    setStartDate(moment(date).format('YYYY-MM-DD'));
  };

  const handleEndDate = (date: any) => {
    setEndDate(moment(date).format('YYYY-MM-DD'));
  };

  const handleApply = () => {
    props.handleApply(startDate, endDate);
  };

  return (
    <Box>
      <MuiPickersUtilsProvider utils={CustomDateFnsUtils}>
        <Grid container alignItems="center" justify="center" spacing={3}>
          <Grid item xs={3}>
            <KeyboardDatePicker
              format="MM/dd/yyyy"
              variant="inline"
              label={'From'}
              key="fromDate"
              data-id="filter-from-date"
              value={moment(startDate).format('YYYY-MM-DD')}
              autoOk={true}
              onChange={handleStartDate}
              animateYearScrolling={false}
              inputProps={{ 'aria-label': 'date picker' }}
              maxDate={new Date()}
            />
          </Grid>
          <Grid item xs={3}>
            <KeyboardDatePicker
              format="MM/dd/yyyy"
              variant="inline"
              key="toDate"
              data-id="filter-to-date"
              label={'To'}
              value={moment(endDate).format('YYYY-MM-DD')}
              autoOk={true}
              onChange={handleEndDate}
              animateYearScrolling={false}
              inputProps={{ 'aria-label': 'date picker' }}
              minDate={startDate}
              // maxDate={ moment(startDate).add(30, 'days')}
            />
          </Grid>
          <Grid item xs={2}>
            <Button data-id="Disable-Button" variant="contained" color="primary" disableElevation onClick={handleApply}>
              Apply
            </Button>
          </Grid>
        </Grid>
      </MuiPickersUtilsProvider>
    </Box>
  );
};

export default DateComp;
